export const FETCH_USERS = "FETCH_USERS";
export const LOAD_MORE_USERS = "LOAD_MORE_USERS";
export const DISABLE_USER = "DISABLE_USER";
export const ENABLE_USER = "ENABLE_USER";
export const SEND_USER_PASSWORD_RESET_MAIL = "SEND_USER_PASSWORD_RESET_MAIL";
